export const FEATURE_NAME = 'reports';

export const LIST = 'list';
export const FILTER = 'filter';

export const PUBLIC_ID = 'publicId';
export const BIRTH = 'birthday';
export const RECEIVER = 'receiver';
export const INSTITUTION = 'institution';
export const FIRST_NAME = 'firstname';
export const LAST_NAME = 'lastname';
export const REPORT_URL = 'url';
export const REPORT_FILE = 'file';
export const RECEIVER_TYPE = 'receiverType';
export const INDEX = 'index';
export const VALIDATION_ISSUES = 'validationIssues';

export const READ = 'read';
export const UNREAD = 'unread';
export const CUSTOM = 'custom';
export const EMPTY = 'empty';

export const REPORT_STATUS = [
  { id: '0', title: 'Wird gedruckt', color: '#f5a623' },
  { id: '1', title: 'Wird gemailt', color: '#f5a623' },
  { id: '5', title: 'In Verarbeitung', color: '#0f7eff' },
  { id: '2', title: 'Versendet', color: '#009838' },
  { id: '3', title: 'Nicht abgeholt', color: '#ff0000' },
  { id: '4', title: 'Retourniert', color: '#ff0000' },
  { id: '6', title: 'Erneut zustellen', color: '#f5a623' },
  { id: '7', title: 'Fehler', color: '#ff0000' },
  { id: '8', title: 'Zurückgerufen', color: '#ff0000' },
];

export const REPORT_STATUSES = REPORT_STATUS.reduce((acc, item) => {
  acc[Number(item.id)] = item;

  return acc;
}, []);
